import Dexie, { type Table } from 'dexie';
import { type VideoDiscoverySite } from 'utils/types';

// We don't want to cache the following fields in IndexedDB
// because they contain sensitive information
export const LOCATION_NO_CACHE_FIELDS = [
  'alarmContacts',
  'alarmConfig',
  'motionAlarmSchedule',
] as const;

type VideoDiscoveryLocationCache = Omit<
  VideoDiscoverySite,
  (typeof LOCATION_NO_CACHE_FIELDS)[number]
>;
export class SolinkDexie extends Dexie {
  locations!: Table<VideoDiscoveryLocationCache>;
  id: string;

  constructor(id: string) {
    super(`solinkDb_${id}`);

    this.id = id;
    this.version(1).stores({
      locations: '++id',
    });
  }

  async clearDatabase() {
    try {
      await this.delete();
      console.debug(`Database ${this.id} is cleared`);
    } catch (err) {
      console.error(`Error clearing database ${this.id}`, err);
    }
  }
}
